// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9da43d82","239":"72387400","455":"2ec41e24"}[chunkId] + ".chunk.js";
};